import { type IconType } from "~/common/components/icon/IconType";
import { PopperTooltip } from "~/common/components/Tooltip";
import { Badge } from "~/common/components/Badge/Badge";
import { Icon } from "~/common/components/icon/Icon";
import { IconSize } from "~/common/components/icon/IconSize";
import classNames from "classnames";

interface PersonalNavItemProps {
  name: string;
  icon?: IconType;
  isActive?: boolean;
  isNotification?: boolean;
  badgeContent?: string | number;
  badgeVariant?: "default" | "new";
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
  "data-test-id"?: string;
  label?: string | null;
  "data-ta-spec"?: string;
  "data-ta-total"?: number | null;
}

export const PersonalNavItem = (props: PersonalNavItemProps) => (
  <div
    onClick={props.onClick}
    data-test-id={props["data-test-id"]}
    className={classNames(
      "scha__personal-nav-item",
      !props.isNotification && {
        "scha__personal-nav-item--active": props.isActive,
      },
    )}
  >
    <div className={"scha__personal-nav-item__details" + (props.isNotification ? "__notification" : "")}>
      <PopperTooltip
        tooltipContent={props.name ? props.name : ""}
        placement="bottom-end"
        isNavigation
        className={classNames("scha__personal-nav__tooltip")}
      >
        <>
          <Badge badgeContent={props.badgeContent ? props.badgeContent : null} variant={props.badgeVariant}>
            {props.icon && (
              <Icon
                type={props.icon}
                size={IconSize.FONT_20}
                data-ta-spec={props["data-ta-spec"]}
                data-ta-total={props["data-ta-total"]}
              />
            )}
          </Badge>
          {props.label && <div className="scha__personal-nav-item__details__label">{props.label}</div>}
        </>
      </PopperTooltip>
    </div>
  </div>
);
